import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({
  selector: '[coinAppEquityPageData]',
  standalone: false
})
export class EquityPageDataDirective {
  viewContainerRef = inject(ViewContainerRef);
}
